import { useTranslation } from 'react-i18next';

export default function Vision() {
  const { t } = useTranslation();

  return (
    <section id="vision" className="bg-[#F8F9FA] py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">
            {t('vision.eyebrow')}
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif text-gray-900 mb-6 sm:mb-8 px-4 whitespace-pre-line">
            {t('vision.title')}
          </h2>
          <div className="max-w-3xl mx-auto space-y-4 px-4">
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed break-keep">
              {t('vision.body1')}
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              {t('vision.body2')}
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-8 sm:gap-16 mt-12 sm:mt-20">
          <div className="flex flex-col items-center">
            <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full border-2 border-[#255485] flex items-center justify-center mb-4 bg-white">
              <i className="ri-team-line text-4xl sm:text-5xl text-[#255485]"></i>
            </div>
            <p className="text-gray-700 font-medium">{t('vision.pillar1')}</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full border-2 border-[#255485] flex items-center justify-center mb-4 bg-white">
              <i className="ri-settings-3-line text-4xl sm:text-5xl text-[#255485]"></i>
            </div>
            <p className="text-gray-700 font-medium">{t('vision.pillar2')}</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full border-2 border-[#255485] flex items-center justify-center mb-4 bg-white">
              <i className="ri-heart-line text-4xl sm:text-5xl text-[#255485]"></i>
            </div>
            <p className="text-gray-700 font-medium">{t('vision.pillar3')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
